export enum MODAL {
  VIEW_DETAIL = "ViewDetail",
  VIEW_SEND_TICKET_LOG = "ViewSendTicketLog",
  NOT_SHOW = "NotShow",
}
